export const AREA_ID_CHOOSE_USER = 4;
export const AREAS = [
  {
    id: 1,
    name: "板橋",
  },
  {
    id: 2,
    name: "千代田",
  },
  {
    id: 3,
    name: "外来",
  },
  {
    id: 4,
    name: "テスター",
  },
  {
    id: 5,
    name: "FiNC",
  },
];

export const NOTICE_AREAS = [
  {
    id: 5,
    name: "全体",
    buttonText: "お知らせ入力",
  },
  {
    id: 1,
    name: "全体(板橋)",
    buttonText: "お知らせ入力",
  },
  {
    id: 2,
    name: "全体(千代田)",
    buttonText: "お知らせ入力",
  },
  {
    id: 3,
    name: "全体(外来) ",
    buttonText: "お知らせ入力",
  },
  {
    id: AREA_ID_CHOOSE_USER,
    name: "個別",
    buttonText: "対象者選択",
  },
];
